import { Button, Callout } from "@blueprintjs/core"
import React from "react"
import { withFormController } from "components/Molecules/FormController"
import ParameterValues from "./ParamterValues"
const Parameter = ({
  data,
  disabled,
  parameterType,
  onAdd,
  onRemove,
  path,
}) => {
  return (
    <>
      {data.map((param, index) => {
        return (
          <ParameterValues
            disabled={disabled}
            key={param.id ? param.id : param.uuid ? param.uuid : index}
            path={path}
            param={param}
            onRemove={onRemove}
          />
        )
      })}
      <Callout
        className="vt-parameters py-2 px-4"
        style={{ background: "#F5F7FB" }}
      >
        <Button
          disabled={disabled}
          minimal={true}
          small={true}
          intent="primary"
          icon="plus"
          onClick={e =>
            onAdd(path, {
              name: "",
              standard: "",
              valueType: "TEXT",
              parameterType: parameterType,
              dropdownValues: [],
            })
          }
        >
          Parameter
        </Button>
      </Callout>
    </>
  )
}

export default withFormController(Parameter)
